<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :size="'md'" :ariaLabel="$t('ia.support_contact.title')">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('ia.support_contact.title')}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        >
        <p class="text-sm leading-6 lg:mb-2">{{$t('ia.support_contact.intro')}}</p>

        <fieldset class="border border-primary-200 rounded-md p-3 dark:border-darkblue-600">
          <legend class="px-2 font-semibold">{{$t('ia.support_contact.callback_title')}}</legend>
          <p class="text-sm text-secondary-600 dark:text-darkblue-300 lg:mb-2">{{$t('ia.support_contact.callback_description')}}</p>
          <el-form ref="ruleForm" :model="form" :rules="rules">
          <div class="lg:mb-2">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">
              {{$t('ia.support_contact.phone_label')}}
            </label>
            <el-form-item class="mb- 3" prop="phone">
              <el-input
                id="support-callback-phone"
                v-model="form.phone"
                type="tel"
                inputmode="tel"
                maxlength="24"
                placeholder="+34 600 000 000">
              </el-input>
            </el-form-item>
            </div>
            <base-button
              class="w-full"
              mode="secondary"
              :text="$t('ia.support_contact.callback_action')"
              @click="requestCallback"
            />
          </el-form>
        </fieldset>

        <div class="flex items-center gap-3 my-5" aria-hidden="true">
          <span class="h-px flex-1 bg-primary-200 dark:bg-darkblue-600"></span>
          <span class="text-xs uppercase text-secondary-500 dark:text-darkblue-300">{{$t('ia.support_contact.or_call')}}</span>
          <span class="h-px flex-1 bg-primary-200 dark:bg-darkblue-600"></span>
        </div>

        <a
          class="flex items-center justify-between border border-secondary rounded-md px-4 py-3 text-secondary hover:bg-primary-50 focus:outline-none focus:ring-2 focus:ring-secondary dark:hover:bg-darkblue-700"
          href="tel:+34911081683"
        >
          <span class="font-semibold">{{$t('ia.support_contact.call_action')}}</span>
          <base-icon name="arrowleft" class="rotate-180" size="sm" :aria-hidden="true" />
        </a>
      </div>
    </template>
    <template slot="footer">
      <div class="flex justify-end px-4 py-2">
        <base-button @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.close')" />
      </div>
    </template>
  </base-dialog-button>
</template>
  
<script>
import { i18n } from '@/i18n'
import { solicitarLlamadaIA } from '@/services/app/solicitarLlamadaIA'

export default
{
  name: 'call-suport-dialog',
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      form: {
        phone: ''
      },
      rules: {
        phone: [
          { required: true, message: i18n.t('validation.phone.phone_required'), trigger: 'blur' },
          { validator: this.validatePhone, trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    dialogOpen (isOpen) {
      if (isOpen) {
        this.form.phone = ''
        this.$nextTick(() => {
          if (this.$refs.ruleForm) this.$refs.ruleForm.clearValidate()
        })
      }
    }
  },
  methods: {
    validatePhone (rule, value, callback) {
      const phone = (value || '').trim()
      if (!phone) return callback()
      const digits = phone.replace(/\D/g, '')
      if (!/^\+?[0-9\s().-]+$/.test(phone) || digits.length < 7 || digits.length > 15) {
        callback(new Error(i18n.t('validation.phone.phone_invalid')))
      } else {
        callback()
      }
    },
    async requestCallback () {
      this.$refs.ruleForm.validate(async valid => {
        if (!valid) return ''
        try {
          const response = await solicitarLlamadaIA({ phoneNumber: this.form.phone.replaceAll(/\s/g, '') })
          if (response?.blnError ?? true) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
          } else {
            this.doFeedback(i18n.t('feedback.success.ia_call_request_msg'), 'success')
            this.toggleDialog()
          }
        } catch (error) {
          this.doFeedback(error)
        }
      })
    },
    toggleDialog () {
      this.$emit('toggleDialog')
    }
  }
}
</script>
  
  <style lang="scss" scoped>.p-3 {
    padding: 0.75rem /* 12px */;
   }.mb-auto {
 margin-bottom: auto;
}</style>
  
